import { GAME_ID, REDUX_ACTIONS } from 'a/sortItOut/data/constants';

const LEVEL_COUNT = 0;

export const initialState = {
  roundsCompleted: 0,
  lastLevelMastered: 0,
  levelPlayedCounters: Array(LEVEL_COUNT).fill(0),
  levelsMastered: Array(LEVEL_COUNT).fill(false),
  hasSeenOnboarding: false,
  levelCount: LEVEL_COUNT,
};

const gameDetailsReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_LAST_LEVEL_MASTERED:
      return {
        ...state,
        lastLevelMastered: action.payload.level,
      };
    case REDUX_ACTIONS.INCREMENT_LEVEL_PLAYED_COUNTER: {
      const levelPlayedCounters = state.levelPlayedCounters.slice();
      levelPlayedCounters[action.payload.level - 1] += 1;

      return {
        ...state,
        levelPlayedCounters,
        roundsCompleted: state.roundsCompleted + 1,
      };
    }
    case REDUX_ACTIONS.SET_LEVEL_MASTERED: {
      const levelsMastered = state.levelsMastered.slice();
      levelsMastered[action.payload.level - 1] = true;

      return {
        ...state,
        levelsMastered,
      };
    }
    case REDUX_ACTIONS.SET_HAS_SEEN_ONBOARDING: {
      return {
        ...state,
        hasSeenOnboarding: true,
      };
    }
    case REDUX_ACTIONS.SET_LEVEL_COUNT: {
      return {
        ...state,
        levelCount: action.payload.count,
        levelPlayedCounters: Array(action.payload.count).fill(0),
        levelsMastered: Array(action.payload.count).fill(false),
      };
    }
    default:
      return state;
  }
};

export default gameDetailsReducer;
